import { CohortSummaryAttributeResult } from '@verantos-dev/types-cohorts';

const getGenderAttributeLabelForKey = (key: string) => {
  switch (key) {
    case 'MALE':
      return 'Male';
    case 'FEMALE':
      return 'Female';
    case 'OTHER':
      return 'Other';
    case 'UNKNOWN':
      return 'Unknown';
    default:
      return key;
  }
};

export const sanitizeAgeAtIndexData = (data: CohortSummaryAttributeResult[] | undefined) => {
  if (!data || data.length === 0) return;

  return data.map((item) => {
    const [start, end] = item.attributeName.split('-');
    return {
      ...item,
      attributeName: `${start} - ${end}`,
    };
  });
};

export const sanitizeGenderData = (data: CohortSummaryAttributeResult[] | undefined) => {
  if (!data || data.length === 0) return;

  return data.map((item) => {
    return {
      ...item,
      attributeName: getGenderAttributeLabelForKey(item.attributeName),
    };
  });
};

// generating range for xAxis labels of cohort characteristics age chart
export const generateRangeArray = (start: number, end: number, interval: number): string[] => {
  const arr: string[] = [];
  for (let i = start; i < end; i += interval) {
    arr.push(`${i} - ${i + interval - 1}`);
  }
  return arr;
};

/**
 * Calculates the axis data for a given range of steps and cohort summary attribute results.
 *
 * @param {string[]} rangeSteps - An array of strings representing the range steps.
 * @param {CohortSummaryAttributeResult[]} data - An array of cohort summary attribute results.
 * @returns {Array<{ attributeName: string, attributeCount: number }>} An array of objects containing the attribute name and attribute count for each step in the range.
 */
export const calculateAxisData = (rangeSteps: string[], data: CohortSummaryAttributeResult[]) => {
  const barStepsValue = rangeSteps.map((step) => {
    const row = data.filter((item) => item.attributeName === step);
    return { ...row[0], attributeName: step, attributeCount: row[0]?.attributeCount || 0 };
  });

  return barStepsValue;
};

export const wrapLabel = (label: string, maxCharCount: number) => {
  const words = label.split(' ');
  let currentLine = '';
  let formattedLabel = '';
  let longestLine = 0;

  words.forEach((word) => {
    if ((currentLine + word).length <= maxCharCount) {
      currentLine += word + ' ';
    } else {
      // Add the current line to the formatted label and start a new line
      formattedLabel += currentLine.trim() + '\n';
      longestLine = Math.max(longestLine, currentLine.trim().length);
      currentLine = word + ' ';
    }
  });

  // Append any remaining words in the last line
  return (formattedLabel += currentLine.trim());
};
